export class MaterialDefaultsCache {
    static getDefaultsFor(material) {
        const type = material.constructor.name;
        const defaults = this.cache.get(type);
        if (defaults) {
            return defaults;
        }
        const defaultMaterial = new material.constructor();
        this.cache.set(type, defaultMaterial);
        return defaultMaterial;
    }
}
MaterialDefaultsCache.cache = new Map();
//# sourceMappingURL=MaterialDefaultsCache.js.map